// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonContainer":"comingSoon_ComingSoonContainer__KLMWW"};